import React from "react"
import { Box, Typography } from "@mui/material"

export default function avgSiteHeader() {
	return {
		setHeaderCellProps: () => ({
			sx: { p: 0, borderBottom: 0, minWidth: 90, backgroundColor: 'primary.main' },
		}),
		render: () => <Box sx={{
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			flexDirection: 'column',
			gap: 1,
			backgroundColor: 'primary.main',
			pt: 1,
			pb: 0,
		}}>
			<Typography sx={{ fontWeight: 'bold' }}>Avg</Typography>
			<Box sx={{ backgroundColor: 'primary.dark', color: 'secondary.contrastText', px: 2, width: '100%', textAlign: 'center' }}>
				<Typography sx={{ fontWeight: 'bold' }}>⌀</Typography>
			</Box>
		</Box>
	}
}
